export default {
  control: (provided) => ({
    ...provided,
    borderRadius: "3px",
    borderWidth: "2px",
    fontSize: "14px",
    color: "#172B4D",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "14px",
    color: "#172B4D",
  }),
};
